import { LogLevel } from "@azure/msal-browser";

const CLIENT_ID="a156f313-56d1-43ae-a404-8e8c60811221"
const TENANT_ID="6d14682b-68a6-4a25-af3d-06615e146b1e"
const REDIRECT_URL="https://documentorai-zenai.mydrreddys.com/"

// const CLIENT_ID="096b87b9-88b5-4929-bebb-b5140f3f25cc"
// const TENANT_ID="b6158728-a3ae-402c-883a-f12396455072"
// const REDIRECT_URL="https://documentoraiqa-zenai.mydrreddys.com/"

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: REDIRECT_URL,
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [],
};
